import React from 'react';
import './HiringPage.css';

const HiringPage = () => {
  // Play the click sound from the public folder
  const playClick = () => {
    const audio = new Audio(`${process.env.PUBLIC_URL}/mixkit-modern-technology-select-3124.wav`);
    audio.play();
  };

  return (
    <div className="hiring-container">

      {/* Hero Section */}
      <div className="hiring-hero">
        <h1>We’re Hiring!</h1>
        <p>Join B&W Scaffolding – Raising standards one level at a time</p>
      </div>

      {/* Job Openings */}
      <div className="job-section">
        <h2>Current Openings</h2>
        <div className="job-cards">
          <div className="job-card">
            <h3>Scaffolder</h3>
            <p>Experienced scaffolders for residential and commercial projects. Competitive pay and safety-focused work environment.</p>
          </div>
          <div className="job-card">
            <h3>Site Supervisor</h3>
            <p>Lead teams on construction sites. Must have experience managing scaffolding projects and teams effectively.</p>
          </div>
          <div className="job-card">
            <h3>Apprentice</h3>
            <p>Kickstart your career with hands-on training in scaffolding. Learn from our experienced team in West Yorkshire.</p>
          </div>
        </div>
      </div>

      {/* How to Apply */}
      <div className="apply-section">
        <h2>How to Apply</h2>
        <p>Send your CV and a short cover letter to our email or give us a call to discuss opportunities.</p>
        <div className="apply-buttons">
          <a href="mailto:b.wscaffoldingco@gmail.com" className="apply-button" onClick={playClick}>Email Us</a>
          <a href="tel:07801753368" className="apply-button" onClick={playClick}>Call Us</a>
        </div>
      </div>

    </div>
  );
};

export default HiringPage;